export default {
    getAllSDM20LHTs: () => {
        return {
            url: '/myfhe/SDM20LHTs',
            method: 'GET'
        };
    },
    getSDM20LHTDetails: SDM20LHTId => {
        return {
            url: '/myfhe/SDM20LHTs/:SDM20LHTId',
            method: 'GET',
            route_params: {
                SDM20LHTId
            }
        };
    }
};



// WEBPACK FOOTER //
// ./environments/myfhe/data/SDM20LHT/api.js